import { Button } from 'src/components/atoms';
import { Accordion } from 'src/components/molecules';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const CaseScreenHeaderDetailsNew = styled.div<{ visible?: boolean }>`
  display: flex;
  padding: 20px 0;
  position: relative;
  z-index: 1;
`;

export const StyledHeaderAccordion = styled(Accordion)`
  box-shadow: ${(props) => props.theme.boxShadows.shadowLarge.boxShadow};

  > :first-child:hover button {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N200
        : props.theme.atlas.semantic.color.surface.variant};
  }
`;

export const CaseIdContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CaseIdTitle = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const NamedOffenderListContainer = styled.div`
  overflow: auto;
  max-height: 215px;
`;

export const InformationBannerContainer = styled.div`
  width: 100%;
  padding: 20px 10px 10px 0px;
  margin: 0 0 0 20px;
`;

export const ImportedButtonTag = styled(Button)`
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N100
      : props.theme.atlas.semantic.color.surface.subtle};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  gap: 8px;
`;

export const ImportedButtonText = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const OriginalCaseIdText = styled.span`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N700
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  text-overflow: ellipsis;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
`;
